/* ============================================================================
   SNAPGOODY — CORE
   DOM helpers · icon set · media/placeholder renderer · reveal · toasts · money
   ========================================================================== */
(function (global) {
  'use strict';

  var SG = global.SG || (global.SG = {});

  /* =============================================================== HELPERS ==*/
  SG.$  = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  SG.$$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  SG.el = function (tag, attrs, html) {
    var n = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === 'class') n.className = attrs[k];
      else if (k === 'text') n.textContent = attrs[k];
      else if (k.slice(0, 2) === 'on' && typeof attrs[k] === 'function') n.addEventListener(k.slice(2), attrs[k]);
      else if (attrs[k] != null) n.setAttribute(k, attrs[k]);
    });
    if (html != null) n.innerHTML = html;
    return n;
  };

  SG.clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
  SG.uid = (function () { var i = 0; return function (p) { i += 1; return (p || 'id') + '-' + i; }; }());
  SG.esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  SG.debounce = function (fn, ms) {
    var t; return function () {
      var a = arguments, c = this;
      clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms || 120);
    };
  };

  /* ================================================================= MONEY ==
     Region-aware. The active region also decides which Shopify product a
     handle resolves to — see catalog.js.
     ======================================================================== */
  SG.regions = {
    UK: { code: 'UK', label: 'United Kingdom', currency: 'GBP', symbol: '£', rate: 1,     locale: 'en-GB' },
    EU: { code: 'EU', label: 'Europe',         currency: 'EUR', symbol: '€', rate: 1.17,  locale: 'de-DE' },
    US: { code: 'US', label: 'United States',  currency: 'USD', symbol: '$', rate: 1.27,  locale: 'en-US' }
  };
  SG.region = 'UK';

  SG.money = function (pennies, region) {
    var r = SG.regions[region || SG.region] || SG.regions.UK;
    var value = (pennies / 100) * r.rate;
    // Keep prices on a .00 / .95 style tier rather than showing raw conversions
    var rounded = Math.round(value * 100) / 100;
    try {
      return new Intl.NumberFormat(r.locale, {
        style: 'currency', currency: r.currency,
        minimumFractionDigits: 2, maximumFractionDigits: 2
      }).format(rounded);
    } catch (e) {
      return r.symbol + rounded.toFixed(2);
    }
  };

  /* ================================================================= ICONS ==*/
  var P = {
    search:      '<circle cx="11" cy="11" r="7"/><path d="M16.4 16.4 21 21"/>',
    user:        '<circle cx="12" cy="8.5" r="4"/><path d="M4.5 20.5c0-3.9 3.4-6 7.5-6s7.5 2.1 7.5 6"/>',
    bag:         '<path d="M6.2 8h11.6l1 12.5H5.2z"/><path d="M9 8V6.2a3 3 0 0 1 6 0V8"/>',
    heart:       '<path d="M12 20.3 4.9 13.4a4.4 4.4 0 0 1 6.2-6.2l.9.9.9-.9a4.4 4.4 0 0 1 6.2 6.2z"/>',
    chevron:     '<path d="M6 9.5 12 15.5 18 9.5"/>',
    chevronUp:   '<path d="M6 14.5 12 8.5 18 14.5"/>',
    chevronR:    '<path d="M9 5.5 15.5 12 9 18.5"/>',
    chevronL:    '<path d="M15 5.5 8.5 12 15 18.5"/>',
    arrowR:      '<path d="M4 12h15.5"/><path d="M14 6.5 19.5 12 14 17.5"/>',
    arrowL:      '<path d="M20 12H4.5"/><path d="M10 6.5 4.5 12 10 17.5"/>',
    plus:        '<path d="M12 5v14M5 12h14"/>',
    minus:       '<path d="M5 12h14"/>',
    close:       '<path d="M6 6l12 12M18 6L6 18"/>',
    check:       '<path d="M4.5 12.5 9.5 17.5 19.5 6.5"/>',
    image:       '<rect x="3.5" y="5" width="17" height="14" rx="1"/><circle cx="9" cy="10" r="1.6"/><path d="M4 17l4.6-4.6 3.4 3.4 3-3L20 17"/>',
    type:        '<path d="M5 7.5V5h14v2.5M12 5v14M9 19h6"/>',
    layers:      '<path d="M12 3.5 21 8.2l-9 4.7-9-4.7z"/><path d="M3 13.2l9 4.7 9-4.7"/>',
    undo:        '<path d="M9 7.5 4.5 12 9 16.5"/><path d="M4.5 12H14a5 5 0 0 1 0 10h-2.5"/>',
    redo:        '<path d="M15 7.5 19.5 12 15 16.5"/><path d="M19.5 12H10a5 5 0 0 0 0 10h2.5"/>',
    zoomIn:      '<circle cx="11" cy="11" r="6.5"/><path d="M11 8.5v5M8.5 11h5M16 16l5 5"/>',
    zoomOut:     '<circle cx="11" cy="11" r="6.5"/><path d="M8.5 11h5M16 16l5 5"/>',
    trash:       '<path d="M4.5 7h15M9.5 7V5.2h5V7M6.5 7l.9 12.3h9.2L17.5 7"/>',
    copy:        '<rect x="8" y="8" width="12" height="12" rx="1"/><path d="M16 8V5.5H4v12H7"/>',
    eye:         '<path d="M2.5 12S6 6.5 12 6.5 21.5 12 21.5 12 18 17.5 12 17.5 2.5 12 2.5 12z"/><circle cx="12" cy="12" r="2.6"/>',
    eyeOff:      '<path d="M4 4l16 16"/><path d="M9.5 9.6A2.6 2.6 0 0 0 12 14.6M6.2 6.6C3.9 8.2 2.5 12 2.5 12S6 17.5 12 17.5c1.5 0 2.8-.3 4-.9M17.4 15.1c2.4-1.6 4.1-3.1 4.1-3.1S18 6.5 12 6.5c-.6 0-1.2 0-1.7.1"/>',
    upload:      '<path d="M12 16.5V4.5M7.5 9 12 4.5 16.5 9"/><path d="M4 19.5h16"/>',
    download:    '<path d="M12 4.5v12M7.5 12 12 16.5 16.5 12"/><path d="M4 19.5h16"/>',
    wand:        '<path d="M5 19l9.5-9.5M16 4.2l.7 2 2 .7-2 .7-.7 2-.7-2-2-.7 2-.7z"/><path d="M19.6 12.4l.5 1.4 1.4.5-1.4.5-.5 1.4-.5-1.4-1.4-.5 1.4-.5z"/>',
    truck:       '<path d="M2.5 7h11v9h-11z"/><path d="M13.5 10.5H18l3 3V16h-7.5"/><circle cx="6.5" cy="18" r="1.8"/><circle cx="17" cy="18" r="1.8"/>',
    leaf:        '<path d="M20 4.5S19 15 12 18c-4 1.7-7.5-.5-7.5-.5S5.5 8 12.5 6c3.5-1 7.5-1.5 7.5-1.5z"/><path d="M4.5 19.5c3-4.5 6-7 10-9"/>',
    shield:      '<path d="M12 3.5 20 6.5v5.6c0 4.6-3.4 7.3-8 8.4-4.6-1.1-8-3.8-8-8.4V6.5z"/><path d="M8.8 12.2l2.2 2.3 4.2-4.6"/>',
    gift:        '<path d="M3.5 9.5h17v4h-17z"/><path d="M5 13.5v7h14v-7M12 9.5v11"/><path d="M12 9.5S10.8 5 8.6 5a2.2 2.2 0 0 0 0 4.5zM12 9.5S13.2 5 15.4 5a2.2 2.2 0 0 1 0 4.5z"/>',
    star:        '<path d="M12 3.5l2.6 5.4 5.9.8-4.3 4.1 1 5.9-5.2-2.8-5.2 2.8 1-5.9L3.5 9.7l5.9-.8z"/>',
    instagram:   '<rect x="3.5" y="3.5" width="17" height="17" rx="4.5"/><circle cx="12" cy="12" r="4"/><circle cx="17" cy="7" r="1"/>',
    pinterest:   '<circle cx="12" cy="12" r="8.5"/><path d="M10 20l2-8M9.6 11.4c0-1.8 1.3-3.2 3-3.2 1.6 0 2.7 1 2.7 2.7 0 2-1.1 3.7-2.7 3.7-.8 0-1.4-.6-1.2-1.4"/>',
    tiktok:      '<path d="M14 4.5v10.2a3.4 3.4 0 1 1-3-3.4"/><path d="M14 4.5c.4 2.3 2 3.7 4.4 3.9"/>',
    rotate:      '<path d="M20 12a8 8 0 1 1-2.6-5.9"/><path d="M20 4.5V9h-4.5"/>',
    move:        '<path d="M12 3.5v17M3.5 12h17"/><path d="M12 3.5 9.6 6M12 3.5 14.4 6M12 20.5 9.6 18M12 20.5 14.4 18M3.5 12 6 9.6M3.5 12 6 14.4M20.5 12 18 9.6M20.5 12 18 14.4"/>',
    info:        '<circle cx="12" cy="12" r="8.5"/><path d="M12 11v5.5M12 7.8v.4"/>',
    alert:       '<path d="M12 4 21 19.5H3z"/><path d="M12 9.5v4.2M12 16.6v.3"/>',
    grid:        '<path d="M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 13h7v7h-7z"/>',
    lock:        '<rect x="5" y="10.5" width="14" height="9.5" rx="1.5"/><path d="M8.2 10.5V7.8a3.8 3.8 0 0 1 7.6 0v2.7"/>',
    crop:        '<path d="M6.5 2.5v15h15"/><path d="M2.5 6.5h15v15"/>',
    flip:        '<path d="M12 3v18"/><path d="M8.5 7.5 4 12l4.5 4.5zM15.5 7.5 20 12l-4.5 4.5z"/>',
    front:       '<rect x="8" y="4" width="12" height="12" rx="1"/><path d="M4 8v12h12"/>',
    back:        '<rect x="4" y="8" width="12" height="12" rx="1"/><path d="M20 16V4H8"/>',
    alignL:      '<path d="M4 4v16M8 8h11M8 15h7"/>',
    alignC:      '<path d="M12 4v16M6.5 8h11M8.5 15h7"/>',
    alignR:      '<path d="M20 4v16M5 8h11M9 15h7"/>',
    center:      '<rect x="4" y="4" width="16" height="16" rx="1"/><path d="M12 8v8M8 12h8"/>',
    palette:     '<path d="M12 3.5a8.5 8.5 0 0 0 0 17c1.4 0 2-.8 2-1.7 0-1.5-1.4-1.6-1.4-2.8 0-.8.7-1.4 1.6-1.4h1.6c2.6 0 4.7-2.1 4.7-4.7 0-3.5-3.8-6.4-8.5-6.4z"/><circle cx="8" cy="10" r="1"/><circle cx="12" cy="7.6" r="1"/><circle cx="16" cy="10" r="1"/>',
    scan:        '<path d="M4 8.5V4h4.5M20 8.5V4h-4.5M4 15.5V20h4.5M20 15.5V20h-4.5"/><path d="M7 12h10"/>',
    sliders:     '<path d="M4 7h10M18 7h2M4 17h4M12 17h8"/><circle cx="16" cy="7" r="2"/><circle cx="10" cy="17" r="2"/>',
    sparkle:     '<path d="M12 3.5l1.9 5.1 5.1 1.9-5.1 1.9-1.9 5.1-1.9-5.1L5 10.5l5.1-1.9z"/><path d="M18.5 16.5l.8 2 2 .8-2 .8-.8 2-.8-2-2-.8 2-.8z"/>',
    swap:        '<path d="M4 8h13M13.5 4.5 17 8l-3.5 3.5"/><path d="M20 16H7M10.5 12.5 7 16l3.5 3.5"/>',
    globe:       '<circle cx="12" cy="12" r="8.5"/><path d="M3.5 12h17M12 3.5c2.2 2.4 3.3 5.3 3.3 8.5S14.2 18.1 12 20.5c-2.2-2.4-3.3-5.3-3.3-8.5S9.8 5.9 12 3.5z"/>',
    ruler:       '<path d="M3 14.5 14.5 3 21 9.5 9.5 21z"/><path d="M7 10.5l2 2M10 7.5l2 2M13 4.5l2 2"/>'
  };

  SG.icon = function (name, cls) {
    var d = P[name] || '';
    return '<svg viewBox="0 0 24 24" aria-hidden="true"' + (cls ? ' class="' + cls + '"' : '') +
      ' fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round">' + d + '</svg>';
  };
  SG.iconFilled = function (name, cls) {
    var d = P[name] || '';
    return '<svg viewBox="0 0 24 24" aria-hidden="true"' + (cls ? ' class="' + cls + '"' : '') +
      ' fill="currentColor" stroke="none">' + d + '</svg>';
  };

  /* ================================================== MEDIA / PLACEHOLDERS ==
     SG.media(slotId, opts)  ->  full <div class="media"> markup
     Every image on the site goes through here, so a missing photo always
     degrades to a labelled placeholder instead of a broken layout.
     ======================================================================== */
  function manifest() { return global.SG_MEDIA || { basePath: '', slots: {}, products: {}, mockups: {} }; }

  function resolve(src) {
    if (!src) return '';
    if (/^(https?:|data:|blob:|\/)/.test(src)) return src;
    return (manifest().basePath || '') + src;
  }
  SG.resolveSrc = resolve;

  function placeholderHTML(label, size, opts) {
    var compact = opts.compact || false;
    var cls = 'ph' + (opts.dark ? ' ph--dark' : '') + (compact ? ' ph--compact' : '');
    return '<div class="' + cls + '" role="img" aria-label="' + SG.esc(label || 'Image placeholder') + '">' +
      '<svg class="ph__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">' + P.image + '</svg>' +
      '<span class="ph__name">' + SG.esc(label || 'Image slot') + '</span>' +
      (size ? '<span class="ph__meta">' + SG.esc(size) + '</span>' : '') +
      '</div>';
  }
  SG.placeholderHTML = placeholderHTML;

  /**
   * @param {string} slotId  key in SG_MEDIA.slots
   * @param {object} [opts]  { className, ratio, focal, label, size, dark, compact, alt, wrap:false }
   */
  SG.media = function (slotId, opts) {
    opts = opts || {};
    var slot = manifest().slots[slotId] || {};
    var label = opts.label || slot.label || slotId;
    var size  = opts.size  || slot.size  || '';
    var src   = resolve(opts.src != null ? opts.src : slot.src);
    var focal = opts.focal || slot.focal || '50% 50%';

    var inner = src
      ? '<img src="' + SG.esc(src) + '" alt="' + SG.esc(opts.alt || slot.alt || label) + '" loading="' + (opts.eager ? 'eager' : 'lazy') + '" style="--focal:' + SG.esc(focal) + '">'
      : placeholderHTML(label, size, opts);

    if (opts.wrap === false) return inner;

    var cls = 'media' + (opts.ratio ? ' media--ratio' : '') + (opts.className ? ' ' + opts.className : '');
    var style = opts.ratio ? ' style="--ratio:' + opts.ratio + '"' : '';
    return '<div class="' + cls + '" data-slot="' + SG.esc(slotId) + '"' + style + '>' + inner + '</div>';
  };

  /** Product photography, keyed by handle + index. */
  SG.mediaProduct = function (handle, index, opts) {
    opts = opts || {};
    var list = manifest().products[handle] || [];
    var src = list[index || 0] || '';
    var title = opts.title || handle;
    return SG.media('generic.product', Object.assign({}, opts, {
      src: src,
      label: title + (index ? ' · view ' + (index + 1) : ''),
      size: opts.size || '1600 × 2000',
      alt: title
    }));
  };

  /** Flat mockup base used inside the studio. */
  SG.mockupSrc = function (handle) { return resolve(manifest().mockups[handle] || ''); };

  /* ================================================================ REVEAL ==*/
  SG.reveal = function (root) {
    var nodes = SG.$$('[data-reveal]', root || document).filter(function (n) { return !n.__revealed; });
    if (!('IntersectionObserver' in global)) {
      nodes.forEach(function (n) { n.classList.add('is-in'); n.__revealed = true; });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    nodes.forEach(function (n) { n.__revealed = true; io.observe(n); });
  };

  /* ================================================================= TOAST ==*/
  SG.toast = function (msg, icon) {
    var host = SG.$('.toast-host');
    if (!host) { host = SG.el('div', { class: 'toast-host' }); document.body.appendChild(host); }
    var t = SG.el('div', { class: 'toast' }, SG.icon(icon || 'check') + '<span>' + SG.esc(msg) + '</span>');
    host.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-in'); });
    setTimeout(function () {
      t.classList.remove('is-in');
      setTimeout(function () { t.remove(); }, 400);
    }, 3200);
  };

  /* ============================================================ BODY LOCK ===*/
  var lockCount = 0;
  SG.lockScroll = function (on) {
    lockCount = Math.max(0, lockCount + (on ? 1 : -1));
    document.body.classList.toggle('is-locked', lockCount > 0);
  };

  /* ============================================================ TINY EVENTS ==*/
  var bus = {};
  SG.on = function (name, fn) { (bus[name] || (bus[name] = [])).push(fn); return fn; };
  SG.off = function (name, fn) { bus[name] = (bus[name] || []).filter(function (f) { return f !== fn; }); };
  SG.emit = function (name, data) { (bus[name] || []).forEach(function (f) { try { f(data); } catch (e) { console.error(e); } }); };

  /* ============================================================ NAVIGATION ==
     Centralised so the single-file preview build can swap in a hash router
     without touching any page markup.
     ======================================================================== */
  SG.url = function (path) {
    if (SG.router && SG.router.href) return SG.router.href(path);
    return path;
  };
  SG.go = function (path) {
    if (SG.router && SG.router.go) { SG.router.go(path); return; }
    global.location.href = path;
  };

  SG.query = function (key) {
    var s = global.location.search;
    if (SG.router && SG.router.query) return SG.router.query(key);
    return new URLSearchParams(s).get(key);
  };

  /* Where the account icon points. In this build it is the local account page;
     theme-bridge.js overrides it with Shopify's own customer account route
     (/account, or the new customer accounts URL) once the theme is installed.
     Everything that links to "the account" goes through here. */
  SG.accountUrl = function () { return SG.url('account.html'); };

  /* Where the Checkout button goes. Overridden by theme-bridge.js with the real
     Shopify checkout route; in this build it is the page that explains that
     checkout is handled by Shopify, so the button is never a dead end. */
  SG.checkoutUrl = function () { return SG.url('page.html?p=checkout'); };

  /* Resolvers the Shopify bridge overrides with real Shopify routes. Keeping
     them here means shared code never has to know which build it is running in.
     In the theme these can return '' when the store has no such object — every
     caller must therefore check before rendering a link. */
  SG.collectionUrl  = function (h) { return SG.url('collection.html?c=' + h); };
  SG.productUrl     = function (h) { return SG.url('product.html?p=' + h); };
  SG.pageUrl        = function (s) { return SG.url('page.html?p=' + s); };
  SG.searchUrl      = function () { return SG.url('collection.html?c=top'); };
  SG.allProductsUrl = function () { return SG.url('collection.html?c=top'); };

}(window));
